import { render, staticRenderFns } from "./Form.global.vue?vue&type=template&id=c1ea42d6&lang=pug&"
import script from "./Form.global.vue?vue&type=script&lang=ts&"
export * from "./Form.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports